import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import DateInput from '@/common/components/base/input/dateInput/DateInput.tsx';
import TextInputWithSelectOnMap from '@/common/components/base/input/mapInput/TextInputWithSelectOnMap';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput.tsx';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup.tsx';
import TimeInput from '@/common/components/base/input/timeInput/TimeInput.tsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import IncidentDetailMainDetailCard from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/incidentDetailMainDetailCard';
import useIncidentDetailsBody from '@/modules/adjusterReportModules/IncidentDetails/pages/accidentDetailsBody/accidentDetailsBody.biz';
import { validateNotFutureDate } from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import { FormProvider, useForm } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box, Stack } from 'styled-system/jsx';

const AccidentDetailsBody = () => {
  const methods = useForm({
    mode: 'onChange',
  });

  return (
    <MainLayout header="titleHeader" title="مشخصات حادثه" hasBottomPadding>
      <FormProvider {...methods}>
        <AccidentDetailsBodyPage />
      </FormProvider>
    </MainLayout>
  );
};

export default AccidentDetailsBody;

const AccidentDetailsBodyPage = () => {
  const {
    cardData,
    damageTypes,
    fetchingDamageType,
    handleDamageTypeOnChange,
    handleSubmit,
    onSubmit,
    damageTypeValue,
    incidentCauseData,
    incidentCausePending,
    cardDataPending,
    atFaultIdentifierPending,
    atFaultIdentifier,
    setValue,
    formState,
  } = useIncidentDetailsBody();
  if (cardDataPending) {
    return <LoadingPage />;
  }

  const eventCauseAccidentItem = damageTypes?.find(
    (item) => item.const === 'accident',
  );
  const eventCauseTheftItem = damageTypes?.find(
    (item) => item.const === 'theft',
  );

  return (
    <Stack>
      <Box className={css({ marginTop: '1rem' })}>
        <IncidentDetailMainDetailCard
          fileNumber={cardData?.order_id!}
          fileType={cardData?.file_type?.const!}
          svgColor={'colors.orange'}
          items={cardData?.detailCardItems ?? []}
          hasBullet={true}
          backgroundColor="orange-2"
          headerClassName={css({ borderColor: 'orange-2' })}
        />
      </Box>

      <TitleDescription marginTop={20} marginBottom={15}>
        فرم زیر را تکمیل کنید
      </TitleDescription>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={css({
          gap: '32px',
          display: 'flex',
          flexDirection: 'column',
        })}
      >
        <ModalInput
          onChange={() => {
            setValue('isDemolitionOccurred', '');
            setValue('eventCause', { label: '', value: undefined });
          }}
          rules={{ required: 'وارد کردن نوع خسارت بدنه الزامی است' }}
          options={damageTypes}
          loading={fetchingDamageType}
          name="bodyDamageType"
          label="نوع خسارت بدنه"
          placeholder="انتخاب کنید"
          searchOptions={{
            onChange: handleDamageTypeOnChange,
            placeholder: 'جستجو خسارت بدنه',
          }}
        />
        {damageTypeValue?.value === eventCauseAccidentItem?.value && (
          <ModalInput
            loading={incidentCausePending}
            options={incidentCauseData}
            name="eventCause"
            label="علت حادثه"
            placeholder="انتخاب کنید"
            rules={{ required: 'وارد کردن علت حادثه اجباری است' }}
          />
        )}
        {damageTypeValue?.value === eventCauseTheftItem?.value && (
          <RadioGroup
            title="آیا تخریب صورت گرفته است؟"
            options={[
              { label: 'بله', value: 'true' },
              { label: 'خیر', value: 'false' },
            ]}
            name={'isDemolitionOccurred'}
            renderRadioButton={(Component) => <Box>{Component}</Box>}
            className={css({ display: 'flex', gap: '65px' })}
          />
        )}

        <DateInput
          label="تاریخ وقوع حادثه"
          buttonText="ثبت"
          modalLabel="تاریخ وقوع حادثه"
          name="eventDate"
          rules={{
            required: 'وارد کردن تاریخ وقوع حادثه اجباری است',
            validate: validateNotFutureDate,
          }}
        />
        <TimeInput
          label="ساعت وقوع حادثه"
          buttonText="ثبت ساعت بازدید"
          modalLabel="ساعت وقوع حادثه"
          name="eventTime"
          rules={{ required: 'وارد کردن ساعت وقوع حادثه اجباری است' }}
        />
        <TextInputWithSelectOnMap
          rules={{ required: 'وارد کردن محل وقوع اجباری است' }}
          label="محل وقوع"
          entranceModalText={
            'در ادامه آدرس محل وقوع حادثه را بر روی نقشه مشخص کنید .'
          }
          mapModalTitle="محل وقوع"
          name="eventLocation"
          phiName="eventLocationPhi"
          lambdaName="eventLocationLambda"
        />
        <ModalInput
          rules={{ required: 'وارد کردن مرجع تعیین مقصر اجباری است' }}
          loading={atFaultIdentifierPending}
          name="atFaultIdentifier"
          label="مرجع تعیین مقصر"
          options={atFaultIdentifier}
          placeholder="انتخاب کنید"
        />

        <LoadingButton
          disabled={!formState.isValid}
          fullWidth
          loading={false}
          mt={8}
        >
          ثبت
        </LoadingButton>
      </form>
    </Stack>
  );
};
